module.exports = __webpack_public_path__ + "static/b1-rtj-159eb9a8a7aeea47bd602ac5dfd361ae.mp4";